var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.resultsNumber)?_c('p',{staticClass:"ebx-results-number",domProps:{"innerHTML":_vm._s(_vm.$options.filters.compileMessage(_vm.$x.messages.resultsFoundHTML,_vm.textParams))}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }